module.exports = __webpack_public_path__ + "static/img/ai_training_tile.e7db7dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_training/ai_training_tile.png
// module id = G6h9
// module chunks = 1